import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';

/**
 * A `.form-control` text input wired to a Material autocomplete panel.
 * The panel itself (mat-autocomplete + options) stays at the call site;
 * this primitive owns the trigger input so composite widgets
 * (app-product-link) carry no raw inputs.
 */
@Component({
  selector: 'app-autocomplete-input',
  templateUrl: './autocomplete-input.component.html',
  styleUrls: ['./autocomplete-input.component.scss'],
})
export class AutocompleteInputComponent {
  @Input() control!: FormControl;
  @Input() matAutocomplete!: MatAutocomplete;
  @Input() inputId = '';
  /** Already-translated placeholder string. */
  @Input() placeholder = '';
  @Input() cssClass = '';
}
